import React from 'react'
import styled from '@emotion/styled'

const Container = styled.svg`
  cursor: pointer;

  :hover {
    opacity: 0.7
  }
`

export default function (props) {
  return (
    <Container width='15' height='15' viewBox='0 0 15 15' fill='none' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.2828 7.5C13.2828 7.75781 13.2668 8 13.2346 8.23437L14.849 9.46875C15.0016 9.57813 15.0418 9.77344 14.9454 9.94531L13.4033 12.5391C13.3069 12.7109 13.1061 12.7734 12.9294 12.7109L11.0099 11.9609C10.6163 12.2578 10.1826 12.5078 9.70872 12.6953L9.41957 14.6797C9.39548 14.8672 9.23485 15 9.04209 15H5.95791C5.76515 15 5.61255 14.8672 5.57239 14.6797L5.28325 12.6953C4.80938 12.5078 4.3837 12.2578 3.98212 11.9609L2.06254 12.7109C1.88584 12.7656 1.68505 12.7109 1.58867 12.5391L0.0465841 9.94531C-0.0417645 9.78906 -0.00160614 9.57813 0.142964 9.46875L1.7734 8.23437C1.73324 8 1.71718 7.74219 1.71718 7.5C1.71718 7.25781 1.7493 7 1.78946 6.76562L0.159028 5.53125C-0.00160613 5.42187 -0.0337329 5.21875 0.0626474 5.05469L1.5967 2.46094C1.69308 2.28906 1.89387 2.22656 2.07057 2.28906L3.99015 3.03906C4.3837 2.75 4.81741 2.49219 5.29128 2.30469L5.58042 0.320312C5.61255 0.132812 5.76515 0 5.95791 0H9.04209C9.23485 0 9.39548 0.132812 9.42761 0.320312L9.71675 2.30469C10.1906 2.49219 10.6163 2.74219 11.0179 3.03906L12.9375 2.28906C13.1142 2.23437 13.3149 2.28906 13.4113 2.46094L14.9534 5.05469C15.0418 5.21094 15.0016 5.42187 14.857 5.53125L13.2266 6.76562C13.2668 7 13.2828 7.25 13.2828 7.5ZM7.5 12C9.98528 12 12 9.98528 12 7.5C12 5.01472 9.98528 3 7.5 3C5.01472 3 3 5.01472 3 7.5C3 9.98528 5.01472 12 7.5 12Z'
        fill='white'
      />
    </Container>
  )
}
